var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// @notes pointer-events seemingly work unreliably directly on svg's so i'm wrapping the icon in a span
import React from "react";
import id from "@irati/utils/id";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { Tooltip } from "./";
import { OverlayPlacement } from "./Overlay";
import { IconWrapper } from "./styled";
var IconTooltip = function (_a) {
    var children = _a.children, _b = _a.placement, placement = _b === void 0 ? OverlayPlacement.Right : _b, OverlayComponent = _a.OverlayComponent, _c = _a.size, size = _c === void 0 ? 16 : _c, _d = _a.icon, icon = _d === void 0 ? IconTypes.information : _d, className = _a.className, props = __rest(_a, ["children", "placement", "OverlayComponent", "size", "icon", "className"]);
    var idNamespace = id("IconTooltip", props);
    return (React.createElement(Tooltip, { id: idNamespace, OverlayComponent: OverlayComponent, placement: placement, tooltipChildren: children },
        React.createElement(IconWrapper, { size: size, className: className },
            React.createElement(Icon, __assign({ icon: icon, size: size }, props)))));
};
export default IconTooltip;
